import script from "./related-article.vue?vue&type=script&lang=js"
export * from "./related-article.vue?vue&type=script&lang=js"

import "./related-article.vue?vue&type=style&index=0&id=6b34cd50&lang=scss"

const __exports__ = script;

export default __exports__